import * as types from '@/store/mutation-types'
import { Repository } from '@/repository/repository'
import { services } from '@/services'
import config from '../../../config'

import { datadogRum as datadog } from '@datadog/browser-rum'

const apiRepository = Repository.call('user')

const _setUserToLogs = ({ id, login, email }) => {
  if (config.datadog.enable) {
    datadog.setUser({
      id,
      name: login,
      email
    })
  }
}

const state = {
  data: {}
}

const getters = {
  authorization: state => state.data.auth,
  getUserName: state => state.data.email,
  status: state => state.data,
  authProfiles: state => state.data.authProfiles
}

const actions = {
  async setAuthorization ({ commit }, userData) {
    const response = await apiRepository.getAuth({
      email: userData.email,
      password: userData.password,
      rememberMe: true
    })
    if (!response.level) return response

    const data = {
      auth: response.headers.authorization,
      email: userData.email
    }
    commit(types.SET_USER_AUTH_HEADER, data)

    const user = await apiRepository.getUserData()
    if (!user.level) return user

    const userPayload = { ...user.data }
    commit(types.SET_DATA_USER, userPayload)

    if (process.env.NODE_ENV !== 'development') _setUserToLogs(userPayload)

    const setUser = services.userService(response.data)
    if (!setUser.login()) return false
    return response
  },
  async setPassword ({ commit }, data) {
    const response = await apiRepository.setPassword(data)
    return response
  },
  async setNewRequestPassword ({ commit }, mail) {
    const response = await apiRepository.setNewRequestPassword({ mail })
    return response
  },
  async create ({ commit }, payload) {
    const response = await apiRepository.createUser(payload)
    return response
  },
  async getProfiles ({ commit }) {
    const profiles = await apiRepository.getUserAuthorities()
    return profiles
  },
  flush ({ commit }) {
    commit(types.SET_FLUSH_USER)
  }
}

const mutations = {
  [types.SET_USER_AUTH_HEADER] (state, data) {
    state.data = { ...data }
  },
  [types.SET_DATA_USER] (state, payload) {
    state.data.info = payload
  },
  [types.SET_FLUSH_USER] (state) {
    state.data = {}
    state.registrations = []
    state.partners = []
    state.profiles = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js